// extracted by mini-css-extract-plugin
module.exports = {"assetsUser":"AssetsUser_assetsUser__2galJ","subTitle":"AssetsUser_subTitle__oeMFt","link":"AssetsUser_link__3cdvF","empty":"AssetsUser_empty__8bZ_g"};